import { useTranslation } from 'react-i18next';

const CHECKLIST_KEYS = [
  'initialSetup.welcome.checklist.departments',
  'initialSetup.welcome.checklist.people',
  'initialSetup.welcome.checklist.systems',
  'initialSetup.welcome.checklist.processes'
] as const;

export function WelcomeStep() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-full flex-col justify-center px-16 py-12">
      <h2 className="mb-12 text-center font-display text-[44px] font-extrabold tracking-[-0.02em] text-foreground">
        {t('initialSetup.wizardHeading')}
      </h2>
      <div className="mx-auto grid max-w-[1080px] grid-cols-[440px_minmax(0,1fr)] items-center gap-16">
        <div className="flex h-[380px] w-[440px] items-center justify-center rounded-full bg-[radial-gradient(circle_at_50%_42%,rgb(15_245_134/0.16),rgb(15_245_134/0.04)_62%,transparent_72%)]">
          <img
            className="h-[170px] w-[170px]"
            src="/assets/images/logo.svg"
            alt={t('initialSetup.topBar.logoAlt')}
          />
        </div>
        <div>
          <h3 className="mb-3.5 text-2xl font-bold text-foreground">
            {t('initialSetup.welcome.title')}
          </h3>
          <p className="mb-[22px] max-w-[56ch] text-base text-fg-secondary">
            {t('initialSetup.welcome.intro')}
          </p>
          <div className="mb-3 text-sm font-bold text-foreground">
            {t('initialSetup.welcome.checklist.title')}
          </div>
          <div className="flex flex-col gap-2.5">
            {CHECKLIST_KEYS.map((labelKey) => (
              <div key={labelKey} className="flex items-center gap-2.5 text-[15px] text-foreground">
                <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-bliks-green-500" />
                {t(labelKey)}
              </div>
            ))}
          </div>
          <p className="mt-[22px] max-w-[56ch] text-sm italic text-fg-subtle">
            {t('initialSetup.welcome.pauseResume')}
          </p>
        </div>
      </div>
    </div>
  );
}
